/* useLogin.tsx */
import checkLoginRequest from '@shared/api/login/checkLoginRequest';
import { routerSelector } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useEffect, useState } from 'react';
import { userSelector } from '@shared/store/slices/user.slice';

/**
 * Check login request every 12 hours
 */
const CHECK_LOGIN_TIME = 12 * 60 * 60 * 1000;

/**
 * Hook to check login status
 */
export default function useLogin() {
  const {
    route: { Page },
  } = useAppSelector(routerSelector);
  const { isAnonymous, token } = useAppSelector(userSelector);
  const [date, setDate] = useState(Date.now());

  useEffect(() => {
    if (!isAnonymous) {
      const newDate = Date.now();
      const timeElapsed = newDate - date;
      if (timeElapsed > CHECK_LOGIN_TIME) {
        setDate(newDate);
        checkLoginRequest(true);
      }
    }
  }, [date, token, Page]);

  return null;
}
